import i18n from '@/plugins/i18n'

export const setPdfOpenButtonClickHandler = (element: HTMLDivElement, clickHandler: (url: string) => void) => {
  if (element) {
    const buttonText = i18n.t('pdfViewer.open')
    element.querySelectorAll('[data-pdf-url]:not([data-pdf-handler-attached])').forEach((item) => {
      // For the ui-core/TextButton component, hierarchy is:
      // <button>
      //  <span>
      //    <span>Open

      const span = item.querySelector('span span')

      if (span) {
        span.textContent = buttonText
      }

      item.setAttribute('data-pdf-handler-attached', '1')
      item.addEventListener('click', () => {
        const url = (item as HTMLButtonElement).dataset.pdfUrl!
        clickHandler(url)
      })
    })
  }
}
